import { api } from "../../services/axios";
import CryptoJS from "crypto-js";

export const useRefresh = () => {
  const handleRefreshUser = async () => {
    try {
      const username = localStorage.getItem("username");
      const password = localStorage.getItem("med");
      const senha = CryptoJS.AES.decrypt(password, "MedSys@341").toString(CryptoJS.enc.Utf8);

      const { data } = await api.post("/login_portal", {
        username,
        senha,
      });

      localStorage.setItem("token", data.JSONID);
      return data.JSONID;
    } catch (error) {
      console.error(error);
    }
  };

  return { handleRefreshUser };
};
